/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'

import * as Login from "rpc/Login/Login"
import * as Comm from "rpc/Comm/Comm"
import * as MisComm from "rpc/MisComm/MisComm"
export var TABLE_SPEC_BillSummary = "BillSummary";
export var TABLE_SPEC_Bill = "Bill";
export var TABLE_SPEC_BillDetail = "BillDetail";
export var TABLE_SPEC_DebtDetail = "DebtDetail";
export var TABLE_SPEC_InterestDetail = "InterestDetail";
export var TABLE_SPEC_RepaymentDetail = "RepaymentDetail";
export var TABLE_SPEC_Custom = "Custom";
export var TABLE_SPEC_CustomGroup = "CustomGroup";
export var TABLE_SPEC_CustomCategory = "CustomCategory";
export var TABLE_SPEC_LogisticsCustom = "LogisticsCustom";
export var TABLE_SPEC_BuyerCustom = "BuyerCustom";
export var TABLE_SPEC_SellerCustom = "SellerCustom";
export var TABLE_SPEC_MergeCustom = "MergeCustom";
export var TABLE_SPEC_CompanyCard = "CompanyCard";
export var TABLE_SPEC_User = "User";
export var TABLE_SPEC_Shop = "Shop";
export var TABLE_SPEC_Contract = "Contract";
export var TABLE_SPEC_ContractSku = "ContractSku";
export var TABLE_SPEC_Contact = "Contact";
export var TABLE_SPEC_OrderAudit = "OrderAudit";
export var TABLE_SPEC_Order = "Order";
export var TABLE_SPEC_Sku = "Sku";
export var TABLE_SPEC_SkuGroup = "SkuGroup";
export var TABLE_SPEC_Spu = "Spu";
export var TABLE_SPEC_ECard = "ECard";
export var TABLE_SPEC_BuyerUser = "BuyerUser";
export var TABLE_SPEC_MallSku = "MallSku";
export var TABLE_SPEC_AftersaleOrder = "AftersaleOrder";
export var TABLE_SPEC_TransferCodeOrder = "TransferCodeOrder";
export var TABLE_SPEC_OrderStat = "OrderStat";
export var TABLE_SPEC_Company = "Company";
export var TABLE_SPEC_SaleUser = "SaleUser";
export var TABLE_SPEC_NewOldCustomConstruct = "NewOldCustomConstruct";
export var TABLE_SPEC_PrivatelyCustomConstruct = "PrivatelyCustomConstruct";
export var TABLE_SPEC_CompanyCustomConstruct = "CompanyCustomConstruct";
export var TABLE_SPEC_CustomConstruct = "CustomConstruct";
export var TABLE_SPEC_CustomGroupPrice = "CustomGroupPrice";
export var TABLE_SPEC_CustomModelPrice = "CustomModelPrice";
export var TABLE_SPEC_CustomCompanyPrice = "CustomCompanyPrice";
export var TABLE_SPEC_ContractPrice = "ContractPrice";
export var TABLE_SPEC_Card = "Card";
export var TABLE_SPEC_MallTab = "MallTab";
export var TABLE_SPEC_SilenceNotify = "SilenceNotify";
export var TABLE_SPEC_PredictOrderSku = "PredictOrderSku";
export var TABLE_SPEC_SilenceNotifyTaskComment = "SilenceNotifyTaskComment";
export var TABLE_SPEC_ContractInvalidSku = "ContractInvalidSku";
export var TABLE_SPEC_OrderLog = "OrderLog";
export var TABLE_SPEC_OrderLogExc = "OrderLogExc";
export var TABLE_SPEC_PotentialCustomer = "PotentialCustomer";
export var TABLE_SPEC_VisitRecord = "VisitRecord";
export var TABLE_SPEC_SilenceNotifyTaskRecentOrder = "SilenceNotifyTaskRecentOrder";
export var TABLE_SPEC_ApplicationFlow = "ApplicationFlow";
export var TABLE_SPEC_Approval = "Approval";
export var TABLE_SPEC_ApplicationRecord = "ApplicationRecord";
export var TABLE_SPEC_ApprovedAppl = "ApprovedAppl";
export var TABLE_SPEC_ApprovedCcAppl = "ApprovedCcAppl";
export var TABLE_SPEC_GjpOrder = "GjpOrder";
export var TABLE_SPEC_GjpOrderDiff_GjpMiss = "GjpOrderDiff_GjpMiss";
export var TABLE_SPEC_GjpOrderDiff_MiMiss = "GjpOrderDiff_MiMiss";
export var TABLE_SPEC_GjpCustomPrice = "GjpCustomPrice";
export var TABLE_SPEC_CustomCompanyConfig = "CustomCompanyConfig";
export var TABLE_SPEC_CustomGroupLimit = "CustomGroupLimit";
export var TABLE_SPEC_CustomBuyer = "CustomBuyer";
export var TABLE_SPEC_CustomBankAccount = "CustomBankAccount";
export var TABLE_SPEC_OrderPayDetail = "OrderPayDetail";
export var TABLE_SPEC_SkuSelect = "SkuSelect";
export var TABLE_SPEC_CustomCompanySelect = "CustomCompanySelect";
export var TABLE_SPEC_SelectOrder = "SelectOrder";
export var TABLE_SPEC_SelectOrderSku = "SelectOrderSku";
export var TABLE_SPEC_CustomPriceManage = "CustomPriceManage";
export var TABLE_SPEC_SkuPriceManage = "SkuPriceManage";
export var TABLE_SPEC_CompanyPriceManage = "CompanyPriceManage";
export var TABLE_SPEC_OneSkuCustomPrice = "OneSkuCustomPrice";
export var TABLE_SPEC_OneCustomSkuPrice = "OneCustomSkuPrice";
export var TABLE_SPEC_OneCompanySkuPrice = "OneCompanySkuPrice";
export var TABLE_SPEC_SkuCustomCompanyPrice = "SkuCustomCompanyPrice";
export var TABLE_SPEC_JoinShopManage = "JoinShopManage";
export var TABLE_SPEC_StoreOrder = "StoreOrder";
export var TABLE_SPEC_SimilarSpuTableSpec = "SimilarSpuTableSpec";
export var TABLE_SPEC_Department = "Department";
export var TABLE_SPEC_NotAuditCustom = "NotAuditCustom";
export var TABLE_SPEC_SkuCustomGroupPrice = "SkuCustomGroupPrice";
export var TABLE_SPEC_AISkuCustomGroupPrice = "AISkuCustomGroupPrice";
export var TABLE_SPEC_SellerSku = "SellerSku";
export var TABLE_SPEC_SellerOrderSku = "SellerOrderSku";
export var TABLE_SPEC_PrintTemplate = "PrintTemplate";
export var TABLE_SPEC_SaleEstimates = "SaleEstimates";
export var TABLE_SPEC_SaleEstimatesSku = "SaleEstimatesSku";

export class TodayOrderStat {
    constructor() {
        this.allWillAuditCount = 0;  // 0 require
        this.todayAuditedCount = 0;  // 1 require
        this.todayOrderCount = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

TodayOrderStat.__json_class__ = 'MisSeller.TodayOrderStat'

export class OrderSkuIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.count = 0;  // 1 require
        this.price = 0;  // 2 require
        this.ss_price = 0;  // 3 require
        this.totalPrice = 0;  // 4 require
        this.totalSendPrice = 0;  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderSkuIn.__json_class__ = 'MisSeller.OrderSkuIn'

export class ModifyOrderIn {
    constructor() {
        this.orderid = 0;  // 0 require
        this.payMethod = "";  // 1 require
        this.arriveBeginTime = null;  // 2 require
        this.arriveEndTime = null;  // 3 require
        this.ss_contactName = "";  // 4 require
        this.ss_contactPhone = "";  // 5 require
        this.ss_contactMobile = "";  // 6 require
        this.nextBillPrice = 0;  // 7 require
        this.skus = [];  // 8 require
        this.province = "";  // 9 require
        this.city = "";  // 10 require
        this.district = "";  // 11 require
        this.address = "";  // 12 require
        this.buyer_companyid = 0;  // 13 optional
        this.buyer_shopid = 0;  // 14 optional
        this.seller_note = "";  // 15 optional
        this.orderCode = "";  // 16 optional
        this.deliveryUserids = [];  // 17 optional
        this.saleUserid = 0;  // 18 optional
        this.openDate = null;  // 19 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

ModifyOrderIn.__json_class__ = 'MisSeller.ModifyOrderIn'

export class ModifyOrderSkuIn {
    constructor() {
        this.orderid = 0;  // 0 require
        this.skus = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ModifyOrderSkuIn.__json_class__ = 'MisSeller.ModifyOrderSkuIn'
export var FORM_SPEC_UpdateUser = "UpdateUser";
export var FORM_SPEC_AddUser = "AddUser";
export var FORM_SPEC_Shop = "Shop";
export var FORM_SPEC_TestUser = "TestUser";
export var FORM_SPEC_Contract = "Contract";
export var FORM_SPEC_ContractBuyer = "ContractBuyer";
export var FORM_SPEC_ContractSeller = "ContractSeller";
export var FORM_SPEC_AddContractSku = "AddContractSku";
export var FORM_SPEC_UpdateContractSku = "UpdateContractSku";
export var FORM_SPEC_Contact = "Contact";
export var FORM_SPEC_UpdateSku = "UpdateSku";
export var FORM_SPEC_Spu = "Spu";
export var FORM_SPEC_ECard = "ECard";
export var FORM_SPEC_CompanyECard = "CompanyECard";
export var FORM_SPEC_UserECard = "UserECard";
export var FORM_SPEC_CompanyConfig = "CompanyConfig";
export var FORM_SPEC_SellerOrderConfig = "SellerOrderConfig";
export var FORM_SPEC_SellerMallConfig = "SellerMallConfig";
export var FORM_SPEC_SellerOrderPrintConfig = "SellerOrderPrintConfig";
export var FORM_SPEC_ApplicationConfig = "ApplicationConfig";
export var FORM_SPEC_AddRepayment = "AddRepayment";
export var FORM_SPEC_CancelRepayment = "CancelRepayment";
export var FORM_SPEC_Company = "Company";
export var FORM_SPEC_CustomCompany = "CustomCompany";
export var FORM_SPEC_UpdateCustom = "UpdateCustom";
export var FORM_SPEC_AddCustom = "AddCustom";
export var FORM_SPEC_CustomGroup = "CustomGroup";
export var FORM_SPEC_CustomCategory = "CustomCategory";
export var FORM_SPEC_JoinCustomCategory = "JoinCustomCategory";
export var FORM_SPEC_SkuGroup = "SkuGroup";
export var FORM_SPEC_CustomGroupPrice = "CustomGroupPrice";
export var FORM_SPEC_Custom = "Custom";
export var FORM_SPEC_Card = "Card";
export var FORM_SPEC_MallTab = "MallTab";
export var FORM_SPEC_SilenceNotify = "SilenceNotify";
export var FORM_SPEC_PredictOrderSku = "PredictOrderSku";
export var FORM_SPEC_SilenceNotifyTaskComment = "SilenceNotifyTaskComment";
export var FORM_SPEC_CustomModelPrice = "CustomModelPrice";
export var FORM_SPEC_CustomCompanyPrice = "CustomCompanyPrice";
export var FORM_SPEC_AddPotentialCustomer = "AddPotentialCustomer";
export var FORM_SPEC_UpdatePotentialCustomer = "UpdatePotentialCustomer";
export var FORM_SPEC_AddVisitRecord = "AddVisitRecord";
export var FORM_SPEC_UpdateVisitRecord = "UpdateVisitRecord";
export var FORM_SPEC_ConfirmReceipt = "ConfirmReceipt";
export var FORM_SPEC_ApplicationAddGroup = "ApplicationAddGroup";
export var FORM_SPEC_App_NotifyUserids = "App_NotifyUserids";
export var FORM_SPEC_CustomCompanyConfig = "CustomCompanyConfig";
export var FORM_SPEC_CustomGroupLimit = "CustomGroupLimit";
export var FORM_SPEC_UpdateShopJoinInfo = "UpdateShopJoinInfo";
export var FORM_SPEC_CustomBankAccount = "CustomBankAccount";
export var FORM_SPEC_CustomBuyer = "CustomBuyer";
export var FORM_SPEC_UpdateOrderExt = "UpdateOrderExt";
export var FORM_SPEC_UpdateReturnOrderExt = "UpdateReturnOrderExt";
export var FORM_SPEC_BatchCreateBuyOrderExt = "BatchCreateBuyOrderExt";
export var FORM_SPEC_Department = "Department";
export var FORM_SPEC_CreateReturnOrderExt = "CreateReturnOrderExt";
export var FORM_SPEC_CreateSellerOrderExt = "CreateSellerOrderExt";
export var FORM_SPEC_updateOrderSkuCost = "updateOrderSkuCost";
export var FORM_SPEC_JoinCustomCompany = "JoinCustomCompany";
export var FORM_SPEC_uploadPrintTemplate = "uploadPrintTemplate";
export var FORM_SPEC_ModifyPrintTemplate = "ModifyPrintTemplate";
export var FORM_SPEC_ImportExcelUpdate = "ImportExcelUpdate";
export var FORM_SPEC_ImportExcelUpdateFormula = "ImportExcelUpdateFormula";
export var FORM_SPEC_CopyCustomCompany = "CopyCustomCompany";
export var FORM_SPEC_SaleEstimates = "SaleEstimates";

export class ECardUsageRule {
    constructor() {
        this.cateids = [];  // 0 optional
        this.spuids = [];  // 1 optional
        this.skuids = [];  // 2 optional
        this.price = 0;  // 3 optional
        this.isOneTime = false;  // 4 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

ECardUsageRule.__json_class__ = 'MisSeller.ECardUsageRule'

export class SigninInfoIn {
    constructor() {
        this.orderid = 0;  // 0 require
        this.signinMethod = "";  // 1 require
        this.signinNote = "";  // 2 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

SigninInfoIn.__json_class__ = 'MisSeller.SigninInfoIn'
export var TARGET_TYPE_USER_ONLY = "userOnly";
export var TARGET_TYPE_COMPANY_SHOP = "companyShop";
export var TARGET_TYPE_COMPANY_ONLY = "companyOnly";

export class CustomUserInfo {
    constructor() {
        this.custom = new MisComm.CustomBasic();  // 0 require
        this.users = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomUserInfo.__json_class__ = 'MisSeller.CustomUserInfo'

export class SetCustomPriceIn {
    constructor() {
        this.customid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.price = 0;  // 2 require
        this.userid = 0;  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SetCustomPriceIn.__json_class__ = 'MisSeller.SetCustomPriceIn'
export var POTENTIAL_CUSTOMER_TYPE_COMPANY = "company";
export var POTENTIAL_CUSTOMER_TYPE_PRIVATELY = "privately";

export class PotentialCustomer {
    constructor() {
        this.taskid = 0;  // 0 require
        this.name = "";  // 1 require
        this.contactName = "";  // 2 require
        this.contactMobile = "";  // 3 require
        this.type = "";  // 4 require
        this.province = "";  // 5 require
        this.city = "";  // 6 require
        this.district = "";  // 7 require
        this.address = "";  // 8 require
        this.modify_time = null;  // 9 require
        this.create_time = null;  // 10 require
        this.chargeUsername = "";  // 11 require
        this.license = "";  // 12 require
        this.foodBizLicense = "";  // 13 require
        this.shopImage = "";  // 14 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PotentialCustomer.__json_class__ = 'MisSeller.PotentialCustomer'

export class PotentialCustomerIn {
    constructor() {
        this.taskid = 0;  // 0 require
        this.name = "";  // 1 require
        this.contactName = "";  // 2 require
        this.contactMobile = "";  // 3 require
        this.type = "";  // 4 require
        this.province = "";  // 5 require
        this.city = "";  // 6 require
        this.district = "";  // 7 require
        this.address = "";  // 8 require
        this.license = "";  // 9 require
        this.foodBizLicense = "";  // 10 require
        this.shopImage = "";  // 11 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PotentialCustomerIn.__json_class__ = 'MisSeller.PotentialCustomerIn'

export class VisitRecord {
    constructor() {
        this.parentid = 0;  // 0 require
        this.modify_time = null;  // 1 require
        this.userid = 0;  // 2 require
        this.content = "";  // 3 require
        this.location = "";  // 4 require
        this.image = "";  // 5 require
        this.username = "";  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

VisitRecord.__json_class__ = 'MisSeller.VisitRecord'

export class VisitRecordIn {
    constructor() {
        this.parentid = 0;  // 0 require
        this.content = "";  // 1 require
        this.location = "";  // 2 require
        this.image = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

VisitRecordIn.__json_class__ = 'MisSeller.VisitRecordIn'

export class MallTabSpuInfoListIn {
    constructor() {
        this.tabid = 0;  // 0 require
        this.type = "";  // 1 require
        this.userid = 0;  // 2 require
        this.groupid = 0;  // 3 require
        this.customid = 0;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

MallTabSpuInfoListIn.__json_class__ = 'MisSeller.MallTabSpuInfoListIn'

export class RequirementIn {
    constructor() {
        this.parentid = 0;  // 0 require
        this.requirementid = 0;  // 1 require
        this.name = "";  // 2 require
        this.spec = "";  // 3 require
        this.barcode = "";  // 4 require
        this.expectedPrice = "";  // 5 require
        this.monthAmount = "";  // 6 require
        this.images = [];  // 7 require
        this.desc = "";  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

RequirementIn.__json_class__ = 'MisSeller.RequirementIn'

export class RequirementInfo {
    constructor() {
        this.parentid = 0;  // 0 require
        this.requirementid = 0;  // 1 require
        this.name = "";  // 2 require
        this.spec = "";  // 3 require
        this.barcode = "";  // 4 require
        this.expectedPrice = "";  // 5 require
        this.monthAmount = "";  // 6 require
        this.images = [];  // 7 require
        this.modify_time = null;  // 8 require
        this.userid = 0;  // 9 require
        this.username = "";  // 10 require
        this.desc = "";  // 11 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

RequirementInfo.__json_class__ = 'MisSeller.RequirementInfo'

export class CustomSkuPriceApplicationIn {
    constructor() {
        this.customid = 0;  // 0 require
        this.skuPrices = [];  // 1 require
        this.expireDays = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomSkuPriceApplicationIn.__json_class__ = 'MisSeller.CustomSkuPriceApplicationIn'

export class CompanySkuPriceApplicationIn {
    constructor() {
        this.customCompanyid = 0;  // 0 require
        this.skuPrices = [];  // 1 require
        this.contractid = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanySkuPriceApplicationIn.__json_class__ = 'MisSeller.CompanySkuPriceApplicationIn'
export var TYPE_CUSTOM_PRICE_CONTRACT = "contract";
export var TYPE_CUSTOM_PRICE_GROUP = "customgroup";
export var TYPE_CUSTOM_PRICE_CUSTOM = "custom";
export var TYPE_CUSTOM_PRICE_COMPANY = "customcompany";

export class PriceModel {
    constructor() {
        this.price = 0;  // 0 require
        this.type = "";  // 1 require
        this.isValid = false;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceModel.__json_class__ = 'MisSeller.PriceModel'

export class SkuAllPriceIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.customid = 0;  // 1 require
        this.customCompanyid = 0;  // 2 require
        this.userid = 0;  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuAllPriceIn.__json_class__ = 'MisSeller.SkuAllPriceIn'

export class SkuAllPrice {
    constructor() {
        this.skuid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.customid = 0;  // 2 require
        this.customCompanyid = 0;  // 3 require
        this.priceList = [];  // 4 require
        this.priceType = "";  // 5 require
        this.floorPrice = 0;  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuAllPrice.__json_class__ = 'MisSeller.SkuAllPrice'

export class SearchMallSpuIn {
    constructor() {
        this.searchIn = new MisComm.SearchSpuIn();  // 0 require
        this.userid = 0;  // 1 require
        this.customid = 0;  // 2 require
        this.groupid = 0;  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchMallSpuIn.__json_class__ = 'MisSeller.SearchMallSpuIn'

export class StoreBillSkuInfo {
    constructor() {
        this.skuid = 0;  // 0 require
        this.name = "";  // 1 require
        this.skuimg = "";  // 2 require
        this.averageCost = 0;  // 3 require
        this.unitName = "";  // 4 require
        this.propSpec = "";  // 5 require
        this.weight = 0.0;  // 6 require
        this.storeid = 0;  // 7 require
        this.count = 0;  // 8 require
        this.batchCode = "";  // 9 require
        this.productionDate = null;  // 10 require
        this.producePlace = "";  // 11 require
        this.brand = "";  // 12 require
        this.expirationDate = 0;  // 13 require
        this.barcode = "";  // 14 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

StoreBillSkuInfo.__json_class__ = 'MisSeller.StoreBillSkuInfo'

export class SignedinOrderIn {
    constructor() {
        this.deliveryUserid = 0;  // 0 require
        this.startTime = null;  // 1 require
        this.endTime = null;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SignedinOrderIn.__json_class__ = 'MisSeller.SignedinOrderIn'

export class DeliveryOrderStat {
    constructor() {
        this.needSignInCount = 0;  // 0 require
        this.daySignedInCount = 0;  // 1 require
        this.monthSignedInCount = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

DeliveryOrderStat.__json_class__ = 'MisSeller.DeliveryOrderStat'

export class ThirdTxnVerify {
    constructor() {
        this.receivable = 0.0;  // 0 require
        this.collected = 0.0;  // 1 require
        this.transferAmount = 0.0;  // 2 require
        this.txnAmount = 0.0;  // 3 require
        this.cashAmount = 0.0;  // 4 require
        this.platformAmount = 0.0;  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ThirdTxnVerify.__json_class__ = 'MisSeller.ThirdTxnVerify'

export class AccountReceivableStat {
    constructor() {
        this.beginBalance = 0;  // 0 require
        this.currentAmount = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AccountReceivableStat.__json_class__ = 'MisSeller.AccountReceivableStat'

export class CommissionsItemInfo {
    constructor() {
        this.key = "";  // 0 require
        this.name = "";  // 1 require
        this.amount = 0;  // 2 require
        this.commissions = 0;  // 3 require
        this.date = null;  // 4 require
        this.desc = "";  // 5 require
        this.rate = 0.0;  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CommissionsItemInfo.__json_class__ = 'MisSeller.CommissionsItemInfo'

export class CommissionsItem {
    constructor() {
        this.info = new CommissionsItemInfo();  // 0 require
        this.subItems = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CommissionsItem.__json_class__ = 'MisSeller.CommissionsItem'

export class UserTotalCommissions {
    constructor() {
        this.userid = 0;  // 0 require
        this.nickname = "";  // 1 require
        this.amount = 0;  // 2 require
        this.paidCommissions = 0;  // 3 require
        this.maxCommissions = 0;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UserTotalCommissions.__json_class__ = 'MisSeller.UserTotalCommissions'

export class UserCommissions {
    constructor() {
        this.userid = 0;  // 0 require
        this.nickname = "";  // 1 require
        this.orderCount = 0;  // 2 require
        this.paidOrderCount = 0;  // 3 require
        this.paidCommissions = 0;  // 4 require
        this.unpaidCommissions = 0;  // 5 require
        this.date = null;  // 6 require
        this.isShowConfirm = false;  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UserCommissions.__json_class__ = 'MisSeller.UserCommissions'

export class UserCommissionsDetail {
    constructor() {
        this.userid = 0;  // 0 require
        this.nickname = "";  // 1 require
        this.grossProfit = 0;  // 2 require
        this.subItems = [];  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UserCommissionsDetail.__json_class__ = 'MisSeller.UserCommissionsDetail'

export class CompanyCommissions {
    constructor() {
        this.orderCount = 0;  // 0 require
        this.paidOrderCount = 0;  // 1 require
        this.paidCommissions = 0;  // 2 require
        this.unpaidCommissions = 0;  // 3 require
        this.date = null;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyCommissions.__json_class__ = 'MisSeller.CompanyCommissions'

export class CompanyCommissionsDetail {
    constructor() {
        this.grossProfit = 0;  // 0 require
        this.subItems = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyCommissionsDetail.__json_class__ = 'MisSeller.CompanyCommissionsDetail'

export class SkuSimpleInfoIn {
    constructor() {
        this.customid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.skuids = [];  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuSimpleInfoIn.__json_class__ = 'MisSeller.SkuSimpleInfoIn'

export class SkuSimpleInfo {
    constructor() {
        this.skuid = 0;  // 0 require
        this.price = 0;  // 1 require
        this.storeCount = 0.0;  // 2 require
        this.canSellCount = 0.0;  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuSimpleInfo.__json_class__ = 'MisSeller.SkuSimpleInfo'

export class CommissionsOrderIn {
    constructor() {
        this.saleUserid = 0;  // 0 require
        this.openDate = 0;  // 1 require
        this.type = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CommissionsOrderIn.__json_class__ = 'MisSeller.CommissionsOrderIn'

export class AROrderStatItem {
    constructor() {
        this.paidCount = 0;  // 0 require
        this.startPayCount = 0;  // 1 require
        this.endPayCount = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AROrderStatItem.__json_class__ = 'MisSeller.AROrderStatItem'

export class AROrderStat {
    constructor() {
        this.dayStatMap = {};  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AROrderStat.__json_class__ = 'MisSeller.AROrderStat'

export class ARStatOrderInfo {
    constructor() {
        this.order = new MisComm.Order();  // 0 require
        this.customName = "";  // 1 require
        this.isPaid = false;  // 2 require
        this.isStartPay = false;  // 3 require
        this.isEndPay = false;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ARStatOrderInfo.__json_class__ = 'MisSeller.ARStatOrderInfo'

export class CustomPriceItem {
    constructor() {
        this.customCompanyid = 0;  // 0 require
        this.customCompanyName = "";  // 1 require
        this.skuid = 0;  // 2 require
        this.price = 0;  // 3 require
        this.expireDays = 0;  // 4 require
        this.expireDate = null;  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomPriceItem.__json_class__ = 'MisSeller.CustomPriceItem'

export class UpdateCustomPriceIn {
    constructor() {
        this.customCompanyid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.price = 0;  // 2 optional
        this.expireDays = 0;  // 3 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

UpdateCustomPriceIn.__json_class__ = 'MisSeller.UpdateCustomPriceIn'

export class CustomGroupPriceIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.groupid = 0;  // 1 require
        this.price = 0;  // 2 require
        this.minPrice = 0;  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomGroupPriceIn.__json_class__ = 'MisSeller.CustomGroupPriceIn'
export var FORMULA_TYPE_AMOUNT = "amount";
export var FORMULA_TYPE_RATIO = "ratio";
export var FORMULA_BASE_PRICE_TYPE_COST = "cost";
export var FORMULA_BASE_PRICE_TYPE_BUY = "buy";
export var FORMULA_PRICE_TYPE_SALEPRICE = "salePrice";
export var FORMULA_PRICE_TYPE_GROUPPRICE = "groupPrice";

export class PriceFormulaItem {
    constructor() {
        this.formulaid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.customGroupid = 0;  // 2 require
        this.type = "";  // 3 require
        this.priceType = "";  // 4 require
        this.basePriceType = "";  // 5 require
        this.amount = 0;  // 6 require
        this.minAmount = 0;  // 7 require
        this.ratio = 0.0;  // 8 require
        this.minRatio = 0.0;  // 9 require
        this.groupName = "";  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceFormulaItem.__json_class__ = 'MisSeller.PriceFormulaItem'

export class SkuPriceFormula {
    constructor() {
        this.skuid = 0;  // 0 require
        this.name = "";  // 1 require
        this.formulaList = [];  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuPriceFormula.__json_class__ = 'MisSeller.SkuPriceFormula'

export class UpdatePriceFormulaItem {
    constructor() {
        this.formulaid = 0;  // 0 require
        this.customGroupid = 0;  // 1 require
        this.type = "";  // 2 require
        this.priceType = "";  // 3 require
        this.amount = 0;  // 4 require
        this.minAmount = 0;  // 5 require
        this.ratio = 0.0;  // 6 require
        this.minRatio = 0.0;  // 7 require
        this.isDelete = false;  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UpdatePriceFormulaItem.__json_class__ = 'MisSeller.UpdatePriceFormulaItem'

export class UpdateSkuPriceFormulaIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.isApply = false;  // 1 require
        this.formulaList = [];  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UpdateSkuPriceFormulaIn.__json_class__ = 'MisSeller.UpdateSkuPriceFormulaIn'

export class ReceivableStatistics {
    constructor() {
        this.userName = "";  // 0 require
        this.waitingPrice = 0;  // 1 require
        this.overduePrice = 0;  // 2 require
        this.userid = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ReceivableStatistics.__json_class__ = 'MisSeller.ReceivableStatistics'

export class CustomInfo {
    constructor() {
        this.name = "";  // 0 require
        this.waitingPrice = 0;  // 1 require
        this.overduePrice = 0;  // 2 require
        this.saleName = "";  // 3 require
        this.companyid = 0;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomInfo.__json_class__ = 'MisSeller.CustomInfo'

export class MisSellerInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='MisSeller',
            interfName='MisSellerInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    getGroupSpuInfoList(skuGroupid,userid,groupid, context) {
        let params = {
            skuGroupid: skuGroupid,
            userid: userid,
            groupid: groupid,
            };
        let req = this.createRequest('getGroupSpuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getGroupSpuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMallTabSpuInfoList(tabid,type,userid,customid,groupid, context) {
        let params = {
            tabid: tabid,
            type: type,
            userid: userid,
            customid: customid,
            groupid: groupid,
            };
        let req = this.createRequest('getMallTabSpuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMallTabSpuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMallTabSpuInfoPageList(infoListIn,pageIn, context) {
        let params = {
            infoListIn: infoListIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('getMallTabSpuInfoPageList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMallTabSpuInfoPageList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchMallSpu(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchMallSpu', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchMallSpu'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSpuDetail(spuid,userid,groupid,customid, context) {
        let params = {
            spuid: spuid,
            userid: userid,
            groupid: groupid,
            customid: customid,
            };
        let req = this.createRequest('getSpuDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSpuDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSkuSimpleInfoList(skuIn, context) {
        let params = {
            skuIn: skuIn,
            };
        let req = this.createRequest('getSkuSimpleInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSkuSimpleInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAgentMallTabList(buyer_userid, context) {
        let params = {
            buyer_userid: buyer_userid,
            };
        let req = this.createRequest('getAgentMallTabList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAgentMallTabList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    cancelOrder(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('cancelOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('cancelOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    auditOrder(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('auditOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('auditOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    confirmOrderReceipt(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('confirmOrderReceipt', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('confirmOrderReceipt'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    changeOrderStatus(orderids,toStatus, context) {
        let params = {
            orderids: orderids,
            toStatus: toStatus,
            };
        let req = this.createRequest('changeOrderStatus', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('changeOrderStatus'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getTodayOrderStat( context) {
        let params = {
            };
        let req = this.createRequest('getTodayOrderStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getTodayOrderStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    modifyOrder(orderIn,commit, context) {
        let params = {
            orderIn: orderIn,
            commit: commit,
            };
        let req = this.createRequest('modifyOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('modifyOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    modifyOrderSkusCount(orderSkuIn, context) {
        let params = {
            orderSkuIn: orderSkuIn,
            };
        let req = this.createRequest('modifyOrderSkusCount', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('modifyOrderSkusCount'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    modifyOrderSkuProduceDate(orderSkuid,orderid,productionDate, context) {
        let params = {
            orderSkuid: orderSkuid,
            orderid: orderid,
            productionDate: productionDate,
            };
        let req = this.createRequest('modifyOrderSkuProduceDate', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('modifyOrderSkuProduceDate'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    changeOrderAfterSale(orderid,afterSaleStatus,afterSaleResult, context) {
        let params = {
            orderid: orderid,
            afterSaleStatus: afterSaleStatus,
            afterSaleResult: afterSaleResult,
            };
        let req = this.createRequest('changeOrderAfterSale', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('changeOrderAfterSale'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderStoreBillSkuInfoList(orderid,storeid, context) {
        let params = {
            orderid: orderid,
            storeid: storeid,
            };
        let req = this.createRequest('getOrderStoreBillSkuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderStoreBillSkuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getStoreBillSkuInfoList(storeBillid, context) {
        let params = {
            storeBillid: storeBillid,
            };
        let req = this.createRequest('getStoreBillSkuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getStoreBillSkuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getStoreBillSkuInfo(barcode,storeid, context) {
        let params = {
            barcode: barcode,
            storeid: storeid,
            };
        let req = this.createRequest('getStoreBillSkuInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getStoreBillSkuInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getReturnOrderStoreBillSkuInfoList(returnid, context) {
        let params = {
            returnid: returnid,
            };
        let req = this.createRequest('getReturnOrderStoreBillSkuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getReturnOrderStoreBillSkuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    writeOffTransferCode(transferCodeText, context) {
        let params = {
            transferCodeText: transferCodeText,
            };
        let req = this.createRequest('writeOffTransferCode', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('writeOffTransferCode'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getManagedCompanyNames( context) {
        let params = {
            };
        let req = this.createRequest('getManagedCompanyNames', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getManagedCompanyNames'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getNewUserVCodeByMobile(mobile,vcodeType, context) {
        let params = {
            mobile: mobile,
            vcodeType: vcodeType,
            };
        let req = this.createRequest('getNewUserVCodeByMobile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getNewUserVCodeByMobile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyOrderList(status,pageIn, context) {
        let params = {
            status: status,
            pageIn: pageIn,
            };
        let req = this.createRequest('getCompanyOrderList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyOrderList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSaleOrderList(saleUserid,status,pageIn, context) {
        let params = {
            saleUserid: saleUserid,
            status: status,
            pageIn: pageIn,
            };
        let req = this.createRequest('getSaleOrderList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSaleOrderList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSaleOrderRedPoint(saleUserid, context) {
        let params = {
            saleUserid: saleUserid,
            };
        let req = this.createRequest('getSaleOrderRedPoint', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSaleOrderRedPoint'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomOrderList(customid,pageIn, context) {
        let params = {
            customid: customid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getCustomOrderList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomOrderList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchOrder(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    signinOrder(signinInfo, context) {
        let params = {
            signinInfo: signinInfo,
            };
        let req = this.createRequest('signinOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('signinOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    cashPayOrder(orderid,price, context) {
        let params = {
            orderid: orderid,
            price: price,
            };
        let req = this.createRequest('cashPayOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('cashPayOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomUserList(pageIn,keyword, context) {
        let params = {
            pageIn: pageIn,
            keyword: keyword,
            };
        let req = this.createRequest('getCustomUserList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomUserList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomUserContactList(userid,customid, context) {
        let params = {
            userid: userid,
            customid: customid,
            };
        let req = this.createRequest('getCustomUserContactList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomUserContactList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getNeedSigninOrderList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getNeedSigninOrderList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getNeedSigninOrderList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSignedinOrderList(orderIn,pageIn, context) {
        let params = {
            orderIn: orderIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('getSignedinOrderList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSignedinOrderList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getDeliveryOrderStat( context) {
        let params = {
            };
        let req = this.createRequest('getDeliveryOrderStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getDeliveryOrderStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderInfoListByIds(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('getOrderInfoListByIds', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderInfoListByIds'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getLastOrderSkuList(userid, context) {
        let params = {
            userid: userid,
            };
        let req = this.createRequest('getLastOrderSkuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getLastOrderSkuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getLastSaleSpuList(saleUserid, context) {
        let params = {
            saleUserid: saleUserid,
            };
        let req = this.createRequest('getLastSaleSpuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getLastSaleSpuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createOrder(orderIn,userid, context) {
        let params = {
            orderIn: orderIn,
            userid: userid,
            };
        let req = this.createRequest('createOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    checkOrder(orderIdInfo,userid, context) {
        let params = {
            orderIdInfo: orderIdInfo,
            userid: userid,
            };
        let req = this.createRequest('checkOrder', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('checkOrder'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomGroupList(companyid, context) {
        let params = {
            companyid: companyid,
            };
        let req = this.createRequest('getCustomGroupList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomGroupList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setCustomPrice(priceIn, context) {
        let params = {
            priceIn: priceIn,
            };
        let req = this.createRequest('setCustomPrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setCustomPrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSkuAllPrice(priceIn, context) {
        let params = {
            priceIn: priceIn,
            };
        let req = this.createRequest('getSkuAllPrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSkuAllPrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createPriceSheet(priceSheetIn, context) {
        let params = {
            priceSheetIn: priceSheetIn,
            };
        let req = this.createRequest('createPriceSheet', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createPriceSheet'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updatePriceSheet(priceSheetIn, context) {
        let params = {
            priceSheetIn: priceSheetIn,
            };
        let req = this.createRequest('updatePriceSheet', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updatePriceSheet'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    deletePriceSheet(sheetid, context) {
        let params = {
            sheetid: sheetid,
            };
        let req = this.createRequest('deletePriceSheet', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('deletePriceSheet'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPriceSheetList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getPriceSheetList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPriceSheetList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPriceSheetInfo(sheetid, context) {
        let params = {
            sheetid: sheetid,
            };
        let req = this.createRequest('getPriceSheetInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPriceSheetInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPriceSheetDetail(sheetid, context) {
        let params = {
            sheetid: sheetid,
            };
        let req = this.createRequest('getPriceSheetDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPriceSheetDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateOrCreatePotentialCustomer(customerIn, context) {
        let params = {
            customerIn: customerIn,
            };
        let req = this.createRequest('updateOrCreatePotentialCustomer', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateOrCreatePotentialCustomer'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPotentialCustomerList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getPotentialCustomerList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPotentialCustomerList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPotentialCustomer(taskid, context) {
        let params = {
            taskid: taskid,
            };
        let req = this.createRequest('getPotentialCustomer', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPotentialCustomer'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createVisitRecord(recordIn, context) {
        let params = {
            recordIn: recordIn,
            };
        let req = this.createRequest('createVisitRecord', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createVisitRecord'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getVisitRecordList(taskid,pageIn, context) {
        let params = {
            taskid: taskid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getVisitRecordList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getVisitRecordList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateOrCreateRequirement(requirementIn, context) {
        let params = {
            requirementIn: requirementIn,
            };
        let req = this.createRequest('updateOrCreateRequirement', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateOrCreateRequirement'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getRequirementList(taskid,pageIn, context) {
        let params = {
            taskid: taskid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getRequirementList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getRequirementList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateOrCreateSellerSku(skuIn, context) {
        let params = {
            skuIn: skuIn,
            };
        let req = this.createRequest('updateOrCreateSellerSku', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateOrCreateSellerSku'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    exportSellerSkuList(companyid, context) {
        let params = {
            companyid: companyid,
            };
        let req = this.createRequest('exportSellerSkuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('exportSellerSkuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createCustomSkuPriceApplication(applicationIn, context) {
        let params = {
            applicationIn: applicationIn,
            };
        let req = this.createRequest('createCustomSkuPriceApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createCustomSkuPriceApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createCompanySkuPriceApplication(applicationIn, context) {
        let params = {
            applicationIn: applicationIn,
            };
        let req = this.createRequest('createCompanySkuPriceApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createCompanySkuPriceApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    deleteCustomSkuPrice(skuid,customid,customCompanyid, context) {
        let params = {
            skuid: skuid,
            customid: customid,
            customCompanyid: customCompanyid,
            };
        let req = this.createRequest('deleteCustomSkuPrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('deleteCustomSkuPrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getContractList(customCompanyid, context) {
        let params = {
            customCompanyid: customCompanyid,
            };
        let req = this.createRequest('getContractList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getContractList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getThridTxnStatusChoices( context) {
        let params = {
            };
        let req = this.createRequest('getThridTxnStatusChoices', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getThridTxnStatusChoices'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getThirdTxnVerify(openDate,customCompanyid, context) {
        let params = {
            openDate: openDate,
            customCompanyid: customCompanyid,
            };
        let req = this.createRequest('getThirdTxnVerify', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getThirdTxnVerify'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUncollectedAmount( context) {
        let params = {
            };
        let req = this.createRequest('getUncollectedAmount', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUncollectedAmount'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getStoreAmount( context) {
        let params = {
            };
        let req = this.createRequest('getStoreAmount', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getStoreAmount'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAccountReceivableStat( context) {
        let params = {
            };
        let req = this.createRequest('getAccountReceivableStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAccountReceivableStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanySaleCommissions( context) {
        let params = {
            };
        let req = this.createRequest('getCompanySaleCommissions', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanySaleCommissions'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanySaleCommisssionsDetail(openDate, context) {
        let params = {
            openDate: openDate,
            };
        let req = this.createRequest('getCompanySaleCommisssionsDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanySaleCommisssionsDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserTotalSaleCommissions( context) {
        let params = {
            };
        let req = this.createRequest('getUserTotalSaleCommissions', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserTotalSaleCommissions'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserSaleCommissions(saleUserid, context) {
        let params = {
            saleUserid: saleUserid,
            };
        let req = this.createRequest('getUserSaleCommissions', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserSaleCommissions'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserSaleCommissionsDetail(saleUserid,openDate, context) {
        let params = {
            saleUserid: saleUserid,
            openDate: openDate,
            };
        let req = this.createRequest('getUserSaleCommissionsDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserSaleCommissionsDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setCommissionsPaid(saleUserid,openDate, context) {
        let params = {
            saleUserid: saleUserid,
            openDate: openDate,
            };
        let req = this.createRequest('setCommissionsPaid', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setCommissionsPaid'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCommissionsOrderList(orderIn,pageIn, context) {
        let params = {
            orderIn: orderIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('getCommissionsOrderList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCommissionsOrderList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAROrderStat(statMonth, context) {
        let params = {
            statMonth: statMonth,
            };
        let req = this.createRequest('getAROrderStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAROrderStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getARStatOrderInfoList(statDay,pageIn, context) {
        let params = {
            statDay: statDay,
            pageIn: pageIn,
            };
        let req = this.createRequest('getARStatOrderInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getARStatOrderInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setCustomGroupPrice(customPriceIn, context) {
        let params = {
            customPriceIn: customPriceIn,
            };
        let req = this.createRequest('setCustomGroupPrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setCustomGroupPrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateCustomPrice(updateIn, context) {
        let params = {
            updateIn: updateIn,
            };
        let req = this.createRequest('updateCustomPrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateCustomPrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSkuPriceFormulaList(skuid, context) {
        let params = {
            skuid: skuid,
            };
        let req = this.createRequest('getSkuPriceFormulaList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSkuPriceFormulaList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateSkuPriceFormula(updateIn, context) {
        let params = {
            updateIn: updateIn,
            };
        let req = this.createRequest('updateSkuPriceFormula', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateSkuPriceFormula'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setSkuBasePrice(skuid,basePrice, context) {
        let params = {
            skuid: skuid,
            basePrice: basePrice,
            };
        let req = this.createRequest('setSkuBasePrice', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setSkuBasePrice'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderCanReturnSkuList(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('getOrderCanReturnSkuList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderCanReturnSkuList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getReceivableStatistics(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getReceivableStatistics', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getReceivableStatistics'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomCompanyList(saleUserid,pageIn, context) {
        let params = {
            saleUserid: saleUserid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getCustomCompanyList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomCompanyList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/MisSeller/MisSeller.js